import React from 'react';
import Modify from './modify';
import Table from './table';
import ProductInstanceShape from '../../shapes/product-instance';
import BatchProductInstanceShape from '../../shapes/batch-product-instance';
import PropTypes from 'prop-types';
import { classes } from './styles/modify-table';
import { translate } from 'react-i18next';
import { Button } from 'reactstrap';

class ProductInstanceModifyTableView extends React.Component {

  render() {
    const {
      t,
      product,
      products,
      disabled,
      customers,
      locations,
      jurisdictions,
      onChange,
      batch,
      onToggleBatch,
      onProvision
    } = this.props;
    // Table props
    const {
      items,
      onSelect,
      onUnselect,
      emptyMessage
    } = this.props;
    // Modify props
    const {
      systemStatuses,
      versions,
      onSave,
      onCancel,
      onPush,
      onDelete,
      canSave,
      canPush,
      freeTextProductVersion,
      onToggleFreeTextProductVersion
    } = this.props;
    const onModify = property => {
      return (value) => onChange({
        ...(product || {}),
        [property]: value
      }, property, value);
    };
    return (
      <div className={classes.outerContainer}>
        <div className={classes.headerContainer}>
          <div />
          <h3>{t('modifyTable.header')}</h3>
          <div className={classes.actionsContainer}>
            <Button
              color="primary"
              size="sm"
              disabled={disabled}
              onClick={onToggleBatch}
            >
              {batch ? t('modifyTable.disableBatchAction') : t('modifyTable.enableBatchAction')}
            </Button>
            <Button
              color="danger"
              size="sm"
              disabled={disabled}
              onClick={onProvision}
            >
              {t('modifyTable.provisionAction')}
            </Button>
          </div>
        </div>
        <div className={classes.container}>
          <div className={classes.tableContainer}>
            <Table
              className={classes.table}
              batch={batch}
              items={items}
              onSelect={onSelect}
              onUnselect={onUnselect}
              emptyMessage={emptyMessage}
              selected={batch ? (products || []).map(product => product.uuid) : (product ? product.uuid : null)}
              customers={customers}
              locations={locations}
              jurisdictions={jurisdictions}
              onDelete={onDelete}
            />
          </div>
          <div className={classes.modifyContainer}>
            <Modify
              freeTextProductVersion={freeTextProductVersion}
              onToggleFreeTextProductVersion={onToggleFreeTextProductVersion}
              parentUuid={(product ? product.parentUuid : '') || ''}
              description={(product ? product.description : '') || ''}
              systemIdentifier={(product ? product.systemIdentifier : '') || ''}
              productId={(product ? product.productId : '') || ''}
              productVersion={(product ? product.productVersion : '') || ''}
              systemStatus={(product ? product.systemStatus : '') || ''}
              paidThrough={(product ? product.paidThrough : 0) || 0}
              onParentUuid={onModify('parentUuid')}
              onDescription={onModify('description')}
              onSystemIdentifier={onModify('systemIdentifier')}
              onProductVersion={onModify('productVersion')}
              onSystemStatus={onModify('systemStatus')}
              onPaidThrough={onModify('paidThrough')}
              batch={batch}
              customers={customers}
              locations={locations}
              jurisdictions={jurisdictions}
              systemStatuses={systemStatuses}
              versions={batch ? (
                  Object.keys(versions)
                    .filter(key => !!(products || []).find(({ productId }) => productId === key))
                    .reduce((map, key) => {
                      map[key] = versions[key];
                      return map;
                    }, {})
                ) : versions}
              disabled={(batch ? (products || []).length === 0 : !product) || disabled}
              onSave={onSave}
              onCancel={onCancel}
              onPush={onPush}
              canSave={canSave}
              canPush={canPush}
            />
          </div>
        </div>
      </div>
    )
  }

}

ProductInstanceModifyTableView.propTypes = {
  onToggleBatch: PropTypes.func.isRequired,
  onProvision: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  batch: PropTypes.bool,
  product: PropTypes.oneOfType([
    ProductInstanceShape,
    BatchProductInstanceShape
  ]),
  // Multi select
  products: PropTypes.arrayOf(
    ProductInstanceShape.isRequired
  ),
  items: PropTypes.arrayOf(
    ProductInstanceShape.isRequired
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
  onUnselect: PropTypes.func.isRequired,
  emptyMessage: PropTypes.string,
  disabled: PropTypes.bool,
  customers: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  ),
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  ),
  jurisdictions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    }).isRequired
  ),
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onPush: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  canSave: PropTypes.bool.isRequired,
  canPush: PropTypes.bool.isRequired,
  freeTextProductVersion: PropTypes.bool,
  onToggleFreeTextProductVersion: PropTypes.func
};

export default translate(['productInstance'])(ProductInstanceModifyTableView);



// WEBPACK FOOTER //
// ./src/views/product-instance/modify-table.js